import querystring from 'querystring';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import RouteServiceAlerts from '#/transit-tracker/components/RouteServiceAlerts';
import RouteAlertsSignupForm from '#/transit-tracker/components/RouteAlertsSignupForm';
import DetailViewLayout from '#/components/DetailViewLayout';
import DetailNavHeader from '#/shared/components/DetailNavHeader';
import SEO from '#/shared/components/SEO';
import ROUTES from '#/constants/routes';
import useNavigate from '#/shared/hooks/useNavigate';
import useViewMapControls from '#/map/hooks/useViewMapControls';
import { SHUTTLE_SUB_TYPE } from '#/transit-tracker/constants';
import { useGetRouteBasicsQuery } from '#/services/developerApi';

function RouteServiceAlertsContainer({ routeId, location }) {
  const { generateNavigateBack, generateNavigateClose } = useNavigate();
  const { serviceAlertsViewOpened, viewClosed } = useViewMapControls();

  const [focusEmailInput, setFocusEmailInput] = useState(false);

  useEffect(() => {
    if (location && location.search) {
      const { email } = querystring.parse(location.search.slice(1));
      setFocusEmailInput(email && email === 'true');
    }
  }, [location]);

  useEffect(() => {
    serviceAlertsViewOpened();
    return viewClosed;
  }, [serviceAlertsViewOpened, viewClosed]);

  const { route } = useGetRouteBasicsQuery(null, {
    selectFromResult: ({ data }) => ({ route: data?.[routeId] }),
  });

  const isShuttle = Boolean(route?.routeSubType === SHUTTLE_SUB_TYPE);

  return (
    <>
      {route && (
        <SEO
          metadataId="routeAlerts"
          dynamicValues={{
            routeDescription: route.desc,
            routeNumber: route.id,
          }}
        />
      )}
      <DetailViewLayout
        top={
          <DetailNavHeader
            onBack={generateNavigateBack()}
            onClose={generateNavigateClose([ROUTES.trip, ROUTES.routeById])}
            content={
              route && (
                <FormattedMessage
                  id="alerts.routealertstitle"
                  values={{ route: route.desc }}
                />
              )
            }
          />
        }
        bottom={
          <RouteServiceAlerts routeId={routeId}>
            {route && !isShuttle && (
              <RouteAlertsSignupForm
                routeName={route.desc}
                routeId={routeId}
                focusEmailInput={focusEmailInput}
              />
            )}
          </RouteServiceAlerts>
        }
        hasInverseBackground
      />
    </>
  );
}

RouteServiceAlertsContainer.propTypes = {
  routeId: PropTypes.string,
  location: PropTypes.shape({ search: PropTypes.string }),
};

RouteServiceAlertsContainer.defaultProps = {
  routeId: null,
  location: null,
};

export default RouteServiceAlertsContainer;
